import * as React from "react";
import { Link } from "react-router-dom";

import MRFAPP from '../../../../assets/new-images/MYREDFOLDER-App-Card.png';
import MyFamily from '../../../../assets/our-services-images/my-family.png';
import EmergencyKit from '../../../../assets/our-services-images/emergency-kit.png';

// Same order as the Our Services menu: App, Plan, Go Kits.
const services = [
  {
    title: 'MYREDFOLDER® App',
    content: "Your family's plan, in your pocket. The MYREDFOLDER app is included with Premium membership.",
    image: MRFAPP,
    fit: "contain", // wide artwork (about 2.4:1); show it whole instead of cropping the sides
    navLink: "/ourServices/my-mrf-app",
  },
  {
    title: 'MYREDFOLDER® Plan',
    content: "Create a household plan that answers the questions that matter when routines break down.",
    image: MyFamily,
    navLink: "/ourServices/my-mrf-plan",
  },
  {
    title: 'Go Kits / Supply Kits',
    content: "A digital plan works best alongside physical supplies. Prepare a go kit for each household member, including pets.",
    image: EmergencyKit,
    navLink: "/ourServices/supply-kits",
  },
];

// Three equal service cards. The whole card is one link (the "Read more" link
// is stretched over it, see .mrf-service__link::after in refresh.css).
const OurServices = () => (
  <section className="mrf-section" aria-labelledby="services-heading">
    <div className="mrf-container">
      <h2 id="services-heading" className="mrf-heading mrf-heading--center">Our Services</h2>
      <ul className="mrf-services">
        {services.map((s) => (
          <li key={s.title} className="mrf-service">
            <div className={`mrf-service__media${s.fit === "contain" ? " mrf-service__media--contain" : ""}`}>
              <img src={s.image} alt="" loading="lazy" />
            </div>
            <div className="mrf-service__body">
              <h3 className="mrf-service__title">{s.title}</h3>
              <p className="mrf-service__text">{s.content}</p>
              <Link className="mrf-service__link" to={s.navLink}>
                Read more<span className="visually-hidden"> about {s.title}</span>
                <span aria-hidden="true"> →</span>
              </Link>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default OurServices;
